import React from 'react';

import dynamic from 'next/dynamic';

import { FlexibleDiv } from '@components/formStyles';
import CustomIcon from '@components/utils/CustomIcon';
import { SkipassIcon, BusIcon } from '@assets/icons';
import Typography from '@components/Typography';
import { HotelDetailFeatureCategoryViewModel } from '@api/v3';

import { PackageName, DescriptionRow } from './SummaryCardStyle';
import { getSkipassControl, getTransferServiceControl } from './utils';

const FeatureSkipass = dynamic(() =>
  import('./SummaryCardStyle').then(({ FeatureSkipass }) => FeatureSkipass)
);
const FeatureDesc = dynamic(() =>
  import('./SummaryCardStyle').then(({ FeatureDesc }) => FeatureDesc)
);
const FeatureTransfer = dynamic(() =>
  import('./SummaryCardStyle').then(({ FeatureTransfer }) => FeatureTransfer)
);

const DecriptionsDesktop = ({
  boardType,
  badge,
}: {
  boardType?: string;
  badge?: HotelDetailFeatureCategoryViewModel[];
}) => {
  return (
    <DescriptionRow>
      {boardType ? (
        <PackageName>
          <Typography variant='caption2' color='D400'>
            {boardType}
          </Typography>
        </PackageName>
      ) : null}

      {getSkipassControl(badge) ? (
        <FeatureSkipass>
          <FlexibleDiv>
            <CustomIcon icon={SkipassIcon} />
          </FlexibleDiv>
          <FeatureDesc>Ücretsiz Skipass</FeatureDesc>
        </FeatureSkipass>
      ) : null}
      {getTransferServiceControl(badge) ? (
        <FeatureTransfer>
          <FlexibleDiv>
            <CustomIcon fontSize={18} paletteColor='lightGrey' icon={BusIcon} />
          </FlexibleDiv>
          <FeatureDesc>Ücretsiz Transfer</FeatureDesc>
        </FeatureTransfer>
      ) : null}
    </DescriptionRow>
  );
};

export default DecriptionsDesktop;
